import { z } from "zod";
import { defineEvent } from "./registry.js";
/**
 * Vergi ve beyan takvimi alarmı. Yük KİŞİSEL VERİ TAŞIMAZ; istemci ayrıntıyı yetki denetimli
 * `/tax-obligations` ucundan çeker.
 */
export const taxObligationDueV1 = defineEvent({
    type: "taxcalendar.obligation.due",
    version: 1,
    description: "Vergi / beyan yükümlülüğünün vadesi yaklaştı ya da geçti (eşik başına bir kez)",
    realtime: ["tenant"],
    payload: z.object({
        companyId: z.uuid(),
        obligationId: z.uuid(),
        code: z.string(),
        periodKey: z.string(),
        dueDate: z.iso.date(),
        /** Negatif = vadesi geçmiş. */
        daysLeft: z.number().int(),
        /** Kuruş (dizge); tutar girilmemişse null. */
        amount: z.string().nullable(),
        isPayment: z.boolean(),
    }),
});
//# sourceMappingURL=tax-calendar.v1.js.map